import { gql } from '__generated__';

export const GET_ONE_TENANT_FOR_EMAIL = gql(/* GraphQL */ `
  query getOneTenantForEmail($email: String!) {
    getOneTenantForEmail(email: $email) {
      id
      name
    }
  }
`);
